import React from 'react';
import {
  ActivityCodeChip,
  ActivityEntry
} from './activity-entry';

const REVISION_VERB: Record<string, string> = {
  ADD: 'added',
  DEL: 'removed',
  MOD: 'updated'
};

export enum SystemActivityActionType {
  ASSIGN_PROFILE = 'ASSIGN_PROFILE',
  CASE_VERSION_UPDATE = 'CASE_VERSION_UPDATE',
  LATE_CASE_UPDATE = 'LATE_CASE_UPDATE'
}

export enum SystemActivityEntityType {
  WORKITEM = 'WORKITEM',
  PROCESS_INSTANCE = 'PROCESS_INSTANCE'
}

function capitalizeEntity(s: string) {
  if (!s) {
    return '';
  }
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

const systemActivityFormatter = (activity: CMxAPI.SystemActivity): any => {
  const ts = activity.timestamp;

  if (
    activity.action === SystemActivityActionType.ASSIGN_PROFILE &&
    activity.targetEntityType === SystemActivityEntityType.WORKITEM
  ) {
    return (
      <ActivityEntry
        timestamp={ts}
        actor="System"
        primary={
          <>
            Queue matched{' '}
            <ActivityCodeChip>
              {activity?.metadata?.profileName}
            </ActivityCodeChip>{' '}
            for distribution
          </>
        }
      />
    );
  }

  if (
    (activity.action === SystemActivityActionType.CASE_VERSION_UPDATE ||
      activity.action === SystemActivityActionType.LATE_CASE_UPDATE) &&
    activity.targetEntityType === SystemActivityEntityType.PROCESS_INSTANCE
  ) {
    return (
      <ActivityEntry
        timestamp={ts}
        actor="System"
        primary={
          <>
            Case version updated to{' '}
            <ActivityCodeChip>{activity?.metadata?.caseVersion}</ActivityCodeChip>
          </>
        }
      />
    );
  }

  return (
    <ActivityEntry
      timestamp={ts}
      actor="System"
      primary={
        <>
          System activity{' '}
          <ActivityCodeChip>{activity.action}</ActivityCodeChip>
        </>
      }
    />
  );
};

const cqaActivityFormatter = (item: CQA.ActivityEntry): any => {
  const ts = item.timestamp ?? item.revInfo?.datetime;
  const actor = item.revInfo?.username ?? '';

  if ('code' in item && item.code) {
    const c = item.code;
    const verb = REVISION_VERB[item.revisionType] ?? 'updated';
    const entity = capitalizeEntity(c.entityType);
    const seq = c.transaction?.sequenceNumber;
    return (
      <ActivityEntry
        timestamp={ts}
        actor={actor}
        primary={
          <>
            {entity}{' '}
            <ActivityCodeChip>{c.code}</ActivityCodeChip> {verb}
            {seq != null ? (
              <>
                {' '}
                charge <ActivityCodeChip>{String(seq)}</ActivityCodeChip>
              </>
            ) : null}
          </>
        }
      />
    );
  }

  if ('codeAssessment' in item && item.codeAssessment) {
    const ca = item.codeAssessment;
    const parent = ca.parentCode;
    const verb = REVISION_VERB[item.revisionType] ?? 'updated';
    return (
      <ActivityEntry
        timestamp={ts}
        actor={actor}
        primary={
          <>
            Assessment <ActivityCodeChip>{ca.assessment}</ActivityCodeChip>{' '}
            {verb} role <ActivityCodeChip>{ca.role}</ActivityCodeChip>
            {parent ? (
              <>
                {' '}
                for {capitalizeEntity(parent.entityType)}{' '}
                <ActivityCodeChip>{parent.code}</ActivityCodeChip>
                {parent.transaction?.sequenceNumber != null ? (
                  <>
                    {' '}
                    charge{' '}
                    <ActivityCodeChip>
                      {String(parent.transaction.sequenceNumber)}
                    </ActivityCodeChip>
                  </>
                ) : null}
              </>
            ) : (
              <> n/a</>
            )}
          </>
        }
      />
    );
  }

  return false;
};

export { systemActivityFormatter, cqaActivityFormatter };
